import { axiosClientAuth } from "./base";

export function homepage() {
  return axiosClientAuth.post("page/home");
}

export function getCategories() {
  return axiosClientAuth.get("categories");
}

export function getCategoryCards(id) {
  return axiosClientAuth.get("categories/" + id + "/cards");
}

export function getNoty() {
  return axiosClientAuth.get("get_ll_notification");
}

export function getNotyFilter(id) {
  return axiosClientAuth.get("get_ll_notification?filter="+id);
}

export function deleteNotyNow(id) {
  return axiosClientAuth.post("delete_noty/"+id);
}
